import { produce } from "immer";
import _ from "lodash";
import { tBrandProductAction, tBrandProductState, tProductWithUID, tSetBrandProducts } from "./types";

export const kDefaultBrandProducts: Array<tProductWithUID> = [];

const handleSetBrandProducts = (action: tSetBrandProducts): tBrandProductState => {
  return _.cloneDeep(action.products);
};

export const BrandProductReducer = produce(
  (draft: tBrandProductState = kDefaultBrandProducts, action: tBrandProductAction): tBrandProductState => {
    switch (action.type) {
      case "SET_BRAND_PRODUCTS":
        return handleSetBrandProducts(action);
      default:
        return draft;
    }
  },
);
